import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DatiApiRegione} from '../../model/dati-api-regione';
import {DatiApiNazione} from '../../model/dati-api-nazione';
import {DatiApiProvince} from '../../model/dati-api-province';
import {filter, toArray} from 'rxjs/operators';
import {from} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DatiApiService {
  loading: boolean = false;
  regioni: DatiApiRegione[] = [];
  province: DatiApiProvince[] = [];

  datiApiNazionali: DatiApiNazione[] = [];
  datiApiRegionali: DatiApiRegione[] = [];
  datiApiProvince: DatiApiProvince[] = [];

  datiApiRegionaliFilter: DatiApiRegione[] = [];
  datiApiProvinceFilter: DatiApiProvince[] = [];

  datiApiProvinceSource: DatiApiProvince[] = [];

  constructor(private http: HttpClient) {
  }

  getDatiNazionali() {
    this.loading = true;
    this.http.get(
      `https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-andamento-nazionale-latest.json`)
      .subscribe(res => {
        this.datiApiNazionali = <DatiApiNazione[]>res;
        this.getDatiRegionali();
      },
        error => this.loading = false);
  }

  getDatiRegionali() {
    this.http.get(
      `https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-regioni-latest.json`)
      .subscribe(res => {
        this.datiApiRegionali = <DatiApiRegione[]>res;
        from(this.datiApiRegionali).pipe(toArray()).subscribe(
          res => {
            let result = JSON.parse(JSON.stringify(res));
            this.regioni = <any>result;
            this.datiApiRegionaliFilter = <DatiApiRegione[]>result;
            this.getDatiProvinciali();
          },
          error => this.loading = false);
      });
  }

  getDatiProvinciali() {
    this.http.get(
      `https://raw.githubusercontent.com/pcm-dpc/COVID-19/master/dati-json/dpc-covid19-ita-province-latest.json`)
      .subscribe(res => {
        this.datiApiProvinceSource = <DatiApiProvince[]>res;
        from(this.datiApiProvinceSource).pipe(toArray()).subscribe(
          res => {
            let result = JSON.parse(JSON.stringify(res));
            this.datiApiProvince = <DatiApiProvince[]>result;
            this.loading = false;
          },
          error => this.loading = false);
      });
  }

  getProvince(codiceRegione) {
    const source1$ = from(this.datiApiProvinceSource).pipe(
      filter(m => m['codice_regione'] == codiceRegione), toArray()).subscribe(
      res => {
        let result = JSON.parse(JSON.stringify(res));
        this.province = <DatiApiProvince[]>result;
      });
  }

  filtroRegione(filtro) {
    if (filtro != 0) {
      const source1$ = from(this.datiApiRegionali).pipe(
        filter(m => m['codice_regione'] == filtro), toArray()).subscribe(
        res => {
          let result = JSON.parse(JSON.stringify(res));
          this.datiApiRegionaliFilter = <DatiApiRegione[]>result;
        });
    } else {
      from(this.regioni).pipe(toArray()).subscribe(res =>{
        this.datiApiRegionaliFilter = <DatiApiRegione[]>res
      })
    }
  }

  filtroProvincia(filtro) {
    if (filtro != 0) {
      const source1$ = from(this.province).pipe(
        filter(m => m['codice_provincia'] == filtro), toArray()).subscribe(
        res => {
          let result = JSON.parse(JSON.stringify(res));
          this.datiApiProvinceFilter = <DatiApiProvince[]>result;
        });
    } else {
      from(this.province).pipe(toArray()).subscribe(res =>
        this.datiApiProvinceFilter = <DatiApiProvince[]>res);
    }
  }
}
